import React from 'react'
import classnames from 'classnames'

import { Item, ItemCategory, ItemCupType } from '../../../core/items'
import { getItemTranslation } from '../../../core/i18n'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'
import { itemInfoTableContent } from './new-item-content'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
  onChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void
}

const cupTypes: Array<{ value: ItemCupType; label: string }> = [
  { value: 1, label: 'ホット' },
  { value: 2, label: 'アイス' },
]
const category: Array<{ value: ItemCategory; label: string }> = [
  { value: 'hot', label: 'ホット' },
  { value: 'ice', label: 'アイス' },
  { value: 'hot_latte', label: 'ホットラテ' },
  { value: 'ice_latte', label: 'アイスラテ' },
  { value: 'hot_milk', label: 'ホットミルク' },
  { value: 'ice_milk', label: 'アイスミルク' },
]

const ItemInfoForm: React.FC<Props> = props => {
  const { activeLanguage } = props
  const isEnglishMode = activeLanguage === LANGUAGE_CODES.ENGLISH

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.itemInfoTable}`}>
        <tbody>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.name}</td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? props.item.name || ''
                    : getItemTranslation(
                        props.item.itemTranslations,
                        LANGUAGE_CODES.ENGLISH
                      )?.name || ''
                }
                onChange={props.onChange}
                name={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? 'name'
                    : 'itemTranslations.en_US.name'
                }
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.price}</td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={props.item.price || ''}
                onChange={props.onChange}
                name="price"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.priceExcludingTax}</td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={props.item.priceExcludingTax || ''}
                onChange={props.onChange}
                name="priceExcludingTax"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>
              {itemInfoTableContent.disposalSeconds}
            </td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={props.item.disposalSeconds || ''}
                onChange={props.onChange}
                name="disposalSeconds"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>
              {itemInfoTableContent.category}
            </td>
            <td className={styles.inputCell}>
              <select
                className={formStyles.input}
                value={props.item.category || ''}
                onChange={props.onChange}
                name="category"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              >
                {category.map(v => (
                  <option key={`cupType-` + v.value} value={v.value}>
                    {v.label}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.cupType}</td>
            <td className={styles.inputCell}>
              <select
                className={formStyles.input}
                value={props.item.cupType || ''}
                onChange={props.onChange}
                name="cupType"
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              >
                {cupTypes.map(v => (
                  <option key={`cupType-` + v.value} value={v.value}>
                    {v.label}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>
              {itemInfoTableContent.description}
            </td>
            <td className={styles.inputCell}>
              <input
                className={formStyles.input}
                value={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? props.item.description
                    : getItemTranslation(
                        props.item.itemTranslations,
                        LANGUAGE_CODES.ENGLISH
                      )?.description || ''
                }
                onChange={props.onChange}
                name={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? 'description'
                    : 'itemTranslations.en_US.description'
                }
              />
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.story}</td>
            <td className={styles.itemInputCell}>
              <textarea
                className={formStyles.textInput}
                value={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? props.item.story
                    : getItemTranslation(
                        props.item.itemTranslations,
                        LANGUAGE_CODES.ENGLISH
                      )?.story || ''
                }
                onChange={props.onChange}
                name={
                  activeLanguage === LANGUAGE_CODES.JAPANESE
                    ? 'story'
                    : 'itemTranslations.en_US.story'
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ItemInfoForm
